<template>
  <v-row justify="center">
    <v-col
      cols="12"
      sm="10"
    >
      <v-dialog
        v-model="show"
        transition="dialog-bottom-transition"
        width="50%"
      >
        <v-card>
          <v-card-title class="light-blue lighten-3">
            <div class="text-h2">
              {{ this.title }}
            </div>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="itemList"
              :options="{ itemsPerPage: 10 }"
              :page="currentPage"
              locale="ru-RU"
              :footer-props="datatableFooter"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  color="primary"
                  @click="deleteItem(item)"
                >
                  mdi-minus-circle-outline
                </v-icon>
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="10">
                <v-text-field
                  v-model="item"
                  label="Новое значение"
                  hint="Добавьте новое значение для элемента Список"
                  outlined
                  :clearable="true"
                />
              </v-col>
              <v-col cols="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="onAdd"
                    >
                      <v-icon large>
                        mdi-plus-circle-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Добавить новое значение</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-space-around">
            <v-btn
              outlined
              @click="onCloseDialog"
            >
              Закрыть
            </v-btn>
            <v-btn
              color="primary"
              @click="onSave"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ItemListEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    headers: {
      default: () => []
    },
    items: {
      default: () => []
    },
    title: {
      default: () => ''
    }
  },
  data: () => ({
    currentPage: 0,
    datatableFooter: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    item: '', //  {  value: '' },
    itemList: [],
    pageStart: 0,
    pageStop: 0,
    // itemList: []
  }),
  computed: {
    show: {
      get: function () {
        return this.dialogVisible
      },
      set: function () {
        this.$emit("close")
      }
    }
  },
  watch: {
    items () {
      this.itemList = []
      this.items.map(m => this.itemList.push({ value: m }))
      console.log('watch this.items', this.items)
    }
  },
  mounted () {
    console.log('this.items', this.items)
    this.items.map(m => this.itemList.push({ value: m }))
    // this.itemList = this.items
  },
  methods: {
    deleteItem (item) {
      console.log(item)
      this.itemList = this.itemList.filter(f => f !== item)
      console.log('deleted this.itemList', this.itemList)
      // console.log(`currentPage=${this.currentPage}`)
      // this.$emit("getItem", item)
      // this.$emit("close")
    },
    getPagination (item) {
      console.log(`pagination=${JSON.stringify(item)}`)
      this.pageStart = item.pageStart
      this.pageStop = item.pageStop
    },
    onAdd () {
      this.itemList.push({ value: this.item })
      console.log('added this.itemList', this.itemList)
    },
    onCloseDialog () {
      this.$emit("close")
    },
    onSave () {
      this.$emit("save", this.itemList)
      this.$emit("close")
    }
  }
}
</script>

<style scoped></style>
